import React from 'react';
import type { FeatureFlags } from 'constants/feature-flags';
import { localFeatureFlagValues } from 'constants/feature-flags';

export type FeatureFlagsContextValue = {
  featureFlags: FeatureFlags;
  isInitialized: boolean;
};

export const featureFlagsDefaultValue: FeatureFlagsContextValue = {
  featureFlags: localFeatureFlagValues,
  isInitialized: false
};

export const FeatureFlagsContext = React.createContext<FeatureFlagsContextValue>(featureFlagsDefaultValue);
